var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeSemiFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 -0.5 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18.87 15.83v-5.8l-4.12-4.1a3.19 3.19 0 0 0-4.5 0l-4.11 4.1v5.8A3.18 3.18 0 0 0 9.32 19h6.37a3.18 3.18 0 0 0 3.18-3.17Z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "#000",
      fillOpacity: 0.44913629
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.62 6.02a.75.75 0 0 0-1.5 0h1.5Zm-.75 4.02h-.75c0 .2.08.39.22.53l.53-.53Zm1.1 2.15a.75.75 0 1 0 1.06-1.06l-1.06 1.06Zm-13.3-1.63A.75.75 0 1 0 5.6 9.5l1.06 1.06Zm-2.7.57a.75.75 0 0 0 1.06 1.06l-1.06-1.06ZM13.75 19a.75.75 0 0 0 1.5 0h-1.5Zm-4 0a.75.75 0 0 0 1.5 0h-1.5Zm8.37-12.98v4.02h1.5V6.02h-1.5Zm.22 4.55 1.63 1.62 1.06-1.06L19.4 9.5l-1.06 1.06ZM5.61 9.5l-1.64 1.63 1.06 1.06 1.64-1.63L5.6 9.5Zm9.64 9.5v-1.78h-1.5V19h1.5Zm0-1.78a2.75 2.75 0 0 0-2.75-2.75v1.5c.69 0 1.25.56 1.25 1.25h1.5Zm-2.75-2.75a2.75 2.75 0 0 0-2.75 2.75h1.5c0-.69.56-1.25 1.25-1.25v-1.5Zm-2.75 2.75V19h1.5v-1.78h-1.5Z",
    fill: "#000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSemiFilled);
export default __webpack_public_path__ + "static/media/home_semi_filled.87548cb7cfe858f4e2201fa081ed9e7b.svg";
export { ForwardRef as ReactComponent };